import { Divider } from 'antd'
import React, { FunctionComponent, memo } from 'react'

import { BUYBACK_STEP, buybackSteps } from '../../../common/buybackTypes'
import { PROPERTY_TYPES } from '../../../common/drmTypes'
import { BuybackFormBuildingFragment } from '../BuybackFormBuildingFragment/BuybackFormBuildingFragment'
import { BuybackFormCommissionFragment } from '../BuybackFormCommissionFragment/BuybackFormCommissionFragment'
import { BuybackFormCustomizationFragment } from '../BuybackFormCustomizationFragment/BuybackFormCustomizationFragment'
import { BuybackFormDebtsFragment } from '../BuybackFormDebtsFragment/BuybackFormDebtsFragment'
import { BuybackFormDebtsListFragment } from '../BuybackFormDebtsListFragment/BuybackFormDebtsListFragment'
import { BuybackFormFeesFragment } from '../BuybackFormFeesFragment/BuybackFormFeesFragment'
import { BuybackFormIncomeFragment } from '../BuybackFormIncomeFragment/BuybackFormIncomeFragment'
import { BuybackFormParametersFragment } from '../BuybackFormParametersFragment/BuybackFormParametersFragment'
import { BuybackFormProcessCostsFragment } from '../BuybackFormProcessCostsFragment/BuybackFormProcessCostsFragment'
import { BuybackFormSummaryFragment } from '../BuybackFormSummaryFragment/BuybackFormSummaryFragment'
import { BuybackFormTitle as Title } from '../BuybackFormTitle/BuybackFormTitle'
import { BuybackFormUnitFragment } from '../BuybackFormUnitFragment/BuybackFormUnitFragment'
import type { MonitNode } from '../PriceEstimateSelectBox/PriceEstimateSelectBox'

export interface BuybackFormStepsProps {
  current: number
  priceEstimates?: MonitNode[]
  propertyType: PROPERTY_TYPES
  loading?: boolean
}

const propertyTypeTitle = (type: PROPERTY_TYPES) => {
  switch (type) {
    case PROPERTY_TYPES.UNIT:
      return 'Parametry bytové jednotky'
    case PROPERTY_TYPES.BUILDING:
      return 'Parametry rodinného domu'
    case PROPERTY_TYPES.AREA:
      return 'Parametry pozemku'
    default:
      return 'Parametry nemovitosti'
  }
}

export const BuybackFormSteps: FunctionComponent<BuybackFormStepsProps> = memo(
  ({ current, priceEstimates, loading, propertyType }) => {
    switch (buybackSteps[current].content) {
      case BUYBACK_STEP.PROPERTY:
        return (
          <>
            <Title title={propertyTypeTitle(propertyType)} />
            <BuybackFormParametersFragment
              priceEstimates={priceEstimates}
              loading={loading}
            />
            {propertyType === PROPERTY_TYPES.BUILDING && (
              <BuybackFormBuildingFragment />
            )}
            {propertyType === PROPERTY_TYPES.UNIT && (
              <BuybackFormUnitFragment />
            )}
          </>
        )
      case BUYBACK_STEP.FINANCE:
        return (
          <>
            <Title title="Finance" />
            <BuybackFormIncomeFragment />

            <Title title="Závazky" />
            <BuybackFormDebtsListFragment />
            <BuybackFormDebtsFragment />

            <Title title="Administrativní poplatky" />
            <BuybackFormProcessCostsFragment />

            <Divider />
            <BuybackFormCommissionFragment />
          </>
        )
      case BUYBACK_STEP.LIVING:
        return (
          <>
            <Title title="Měsíční platby" description="Služby a energie" />
            <BuybackFormFeesFragment />
          </>
        )
      case BUYBACK_STEP.OFFER:
        return (
          <>
            <Title title="Nabídka" />
            <BuybackFormCustomizationFragment propertyType={propertyType} />

            <Title title="Souhrn" />
            <BuybackFormSummaryFragment />
          </>
        )
      default:
        return null
    }
  }
)
